import { gql } from 'graphql-tag';

export const GET_SETTLEMENTS_IN_PERIOD = gql`
  query Idb2ca497996827cc8c5c8eda774ce61bd(
    $companyId: ID!
    $excludeNonPreparedPayables: Boolean!
    $includeAlreadyExported: Boolean!
    $fromCreationDate: Date!
    $toCreationDate: Date!
  ) {
    __typename
  }
`;
